module.exports = __webpack_public_path__ + "static/media/faded-linear-gradients-background.4e6f05cf.png";